import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const ProductionLinked = React.lazy(
  () => import('components/Production/Linked/Linked'),
);

function ScreensProductionLinked(params: Readonly<RoutePrivateProps>) {
  return (
    <BaseLayout>
      <DocumentTitle>Production Management</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <ProductionLinked
          id={parseInt(params.id as string, 10)}
          key={params.id}
        />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensProductionLinked;
